import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, inject, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { MatDialog, MatDialogModule, MatDialogConfig } from '@angular/material/dialog';
import { MemberInsurerProfileComponent } from '../../member-insurer-profile/member-insurer-profile.component';
import { MemberInsurerServiceService } from '@app/modules/lps-member-login/services/member-insurer-service.service';
import { MemberInsurerRestService } from '@app/modules/lps-member-login/services/member-insurer-rest.service';
import { ThemeserviceService } from '../../theme/themeservice.service';
import { Roles } from '@app/modules/lps-member-login/models/commonmodel';
import { interval, Subject, Subscription, takeUntil } from 'rxjs';
import { formatDistanceToNow, isToday } from 'date-fns';
import { trigger, transition, style, animate } from '@angular/animations';
import { NotificationService } from '../../shared/services/notifications.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { InitialsPipe } from '../../shared/pipes/intials.pipe';
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, MatTooltipModule, CommonModule, MatDialogModule, InitialsPipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  animations: [
    trigger('fadeAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'translateY(10px)' }))
      ])
    ])
  ]
})
export class HeaderComponent {


  @Input() isCollapsed = false;
  readonly dialog = inject(MatDialog)
  showDropdown = false;
  showNotifications = false;
  notifications: any = [];
  role = this.memberService.getLoginUserRole();
  roleAccess = this.memberService.getUserAccess();
  enumRole = Roles;
  startLogoutAnimation = false;
  private notificationSub!: Subscription;
  activeTab: string = 'overview';
  userAccess = this.memberService.getUserAccess();

  // notifications: any;
  userName: string = this.memberService.getLoginUserName();
  userId: string = this.memberService.getLoginUserId();
  private unsubscribe = new Subject<void>();

  constructor(private sanitizer: DomSanitizer, private router: Router, private eRef: ElementRef, private memberService: MemberInsurerServiceService,
    private restService: MemberInsurerRestService, private theme: ThemeserviceService, private notificationService: NotificationService
  ) { }

  openProfile() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '600px';
    const dialogRef = this.dialog.open(MemberInsurerProfileComponent, dialogConfig)
  }

  emoji: string = '👋';
  greetingMessage: string = 'Welcome in,';
  subText: string = 'Everything you need is, right here...';

  currentEmoji: string = '';
  messagePrefix: string = '';
  messageSuffix: string = '';

  private messages = {
    morning: [
      { emoji: '☀️', prefix: "Rise and shine,", suffix: "! Ready for a productive day? 🚀" },
      { emoji: '🍳', prefix: "Good morning,", suffix: "! Hope you had a refreshing night. Did you grab breakfast?" },
      { emoji: '☕', prefix: "Hello,", suffix: "! Time for some fresh ideas. 💡" },
      { emoji: '✨', prefix: "A new day, a fresh start,", suffix: "! Let's make it count. ✨" }
    ],
    afternoon: [
      { emoji: '💪', prefix: "Good afternoon,", suffix: "! Halfway through, keep up the great work! " },
      { emoji: '🍔', prefix: "Hey,", suffix: "! Lunch plans sorted? Let's make the most of the afternoon. " },
      { emoji: '🎯', prefix: "Welcome back,", suffix: "! What's next on your agenda? " },
      { emoji: '⚡', prefix: "Afternoon energy,", suffix: "! Crushing it, one task at a time. " }
    ],
    evening: [
      { emoji: '🌙', prefix: "Good evening,", suffix: "! Winding down or powering through? " },
      { emoji: '🌆', prefix: "Almost done for the day,", suffix: "! Any exciting plans for the evening? " },
      { emoji: '📊', prefix: "Hello,", suffix: "! Time to review the day's achievements. " },
      { emoji: '😊', prefix: "The day winds down,", suffix: ". Hope it was a good one! " }
    ],
    night: [
      { emoji: '😴', prefix: "Still here,", suffix: "? Remember to get some rest! " },
      { emoji: '✨', prefix: "Late night,", suffix: "! Your dedication is appreciated. Don't forget to recharge! " },
      { emoji: '🌌', prefix: "Working hard,", suffix: "? Take a break if you need one. " },
      { emoji: '🦉', prefix: "Night owl,", suffix: "! Don't let the code bite. " }
    ],
    default: [ // Fallback messages
      { emoji: '👋', prefix: "Welcome in,", suffix: "! Everything you need is, right here..." },
      { emoji: '👍', prefix: "Hello,", suffix: "! Ready to tackle your tasks? Let's go! " }
    ]
  };


  setGreetingMessage() {
    const hours = new Date().getHours();

    if (hours < 12) {
      this.greetingMessage = 'Good morning,';
      this.subText = 'Had your breakfast yet? ☕';
      this.emoji = '🌞';
    } else if (hours < 17) {
      this.greetingMessage = 'Good afternoon,';
      this.subText = 'Hope your day is going well!';
      this.emoji = '🌤️';
    } else if (hours < 21) {
      this.greetingMessage = 'Good evening,';
      this.subText = 'Time to wind down a little.';
      this.emoji = '🌇';
    } else {
      this.greetingMessage = 'Burning the midnight oil,';
      this.subText = 'Don’t forget to rest!';
      this.emoji = '🌙';
    }
  }


  setActiveTab(tabName: string): void {
    this.activeTab = tabName;
    if (this.role == this.enumRole.PROVIDER) {
      if (tabName === 'overview') {
        this.router.navigate(['/dashboard/provider']);
      }
      else if (tabName == 'config') {
        this.router.navigate(['/dashboard/configuration']);
      }
    }
    this.memberService.changeTab(tabName);
  }

  ngOnInit() {
    this.updateWelcomeMessage();
    setInterval(() => this.updateWelcomeMessage(), 60000);

    // this.setGreetingMessage();
    if (this.userAccess == this.enumRole.ADMIN_INSURER || this.userAccess == this.enumRole.ADMIN_PROVIDER)
      this.activeTab = 'config';

    if (this.userAccess != this.enumRole.ADMIN_INSURER && this.userAccess != this.enumRole.ADMIN_PROVIDER && this.memberService.getLoginUserId() && this.role != this.enumRole.SUPER_ADMIN
      && this.userAccess != this.enumRole.ADMIN_DISTRIBUTOR) {
      // Immediately call once
      this.getNotifications();

      // Then poll every 60 seconds (60000 ms)
      this.notificationSub = interval(60000).subscribe(() => {
        this.getNotifications();
      });

    }

    const role = this.memberService.getLoginUserRole();
    const userId = this.memberService.getLoginUserId();
    this.theme.applyTheme(role)

    this.memberService.sideBarTabChanged$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(tab => {
        this.activeTab = tab;
      });
  }

  updateWelcomeMessage(): void {
    const hour = new Date().getHours();
    let selectedMessages: { emoji: string; prefix: string; suffix: string; }[];

    if (hour >= 5 && hour < 12) {
      selectedMessages = this.messages.morning;
    } else if (hour >= 12 && hour < 17) {
      selectedMessages = this.messages.afternoon;
    } else if (hour >= 17 && hour < 22) {
      selectedMessages = this.messages.evening;
    } else {
      selectedMessages = this.messages.night;
    }

    const randomIndex = Math.floor(Math.random() * selectedMessages.length);
    const chosenMessage = selectedMessages[randomIndex];

    this.currentEmoji = chosenMessage.emoji;
    this.messagePrefix = chosenMessage.prefix;
    this.messageSuffix = chosenMessage.suffix;
  }

  allNotifications = true;
  unreadNotifications = false;
  todayNotifications: any[] = [];
  olderNotifications: any[] = [];

  trackById(index: number, item: any) {
    return item.id || index; // Use unique ID if available
  }


  get filteredNotifications() {
    if (this.unreadNotifications) {
      return this.notifications.filter((n: { read: any; }) => !n.read);
    }
    return this.notifications;
  }

  selectAll() {
    this.allNotifications = true;
    this.unreadNotifications = false;
    this.refreshNotifications();
  }

  selectUnread() {
    this.unreadNotifications = true;
    this.allNotifications = false;
    this.refreshNotifications();
  }


  refreshNotifications() {
    const filtered = this.unreadNotifications
      ? this.notifications.filter((n: { read: any; }) => !n.read)
      : this.notifications;

    this.todayNotifications = [];
    this.olderNotifications = [];

    setTimeout(() => {
      this.todayNotifications = filtered.filter((n: { createdon: string | number | Date; }) =>
        isToday(new Date(n.createdon))
      );
      this.olderNotifications = filtered.filter((n: { createdon: string | number | Date; }) =>
        !isToday(new Date(n.createdon))
      );
    }, 10);
  }

  formatTodayDate(dateStr: string) {
    return formatDistanceToNow(new Date(dateStr), { addSuffix: true });
  }

  formatOlderDate(dateStr: string) {
    const date = new Date(dateStr);
    return date.toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  markAsRead(notification: any) {
    this.restService.makeNotificationRead(notification.notificationId).subscribe({
      next: (value) => {
        this.notificationService.showNotification('Maked as read');
        this.getNotifications();
      },
      error: (err) => {
        this.notificationService.showNotification(err.error.message, 'error');
      }
    })
  }

  getNotifications() {
    let userId = this.memberService.getLoginUserId();
    if (this.role == this.enumRole.INSURER) {
      this.restService.getNotificationsForInsurer(userId).subscribe({
        next: (value) => {
          this.notifications = value;
          this.refreshNotifications();
        },
        error: (err) => {
          console.log(err)
        }
      })
    }
    else {
      this.restService.getNotificationsForProvider(userId).subscribe({
        next: (value) => {
          this.notifications = value;
          this.refreshNotifications();
        },
        error: (err) => {
          console.log(err)
        }
      })
    }
  }

  toggleNotificationDropdown() {
    this.showDropdown = false;
    this.showNotifications = !this.showNotifications;
  }

  confirmLogout(): void {
    this.startLogoutAnimation = true;
    console.log(this.startLogoutAnimation);
    setTimeout(() => {
      if (this.memberService.getLoginUserRole() === this.enumRole.INSURER) {
        if (this.memberService.getUserAccess() === this.enumRole.ADMIN_INSURER)
          this.router.navigate(['login/adminInsurer']);
        else
          this.router.navigate(['login/insurer']);
      }
      else if (this.memberService.getLoginUserRole() === this.enumRole.DISTRIBUTOR) {
        if (this.memberService.getUserAccess() === this.enumRole.ADMIN_DISTRIBUTOR)
          this.router.navigate(['login/distributorAdmin']);
        else
          this.router.navigate(['login/distributor']);
      }
      else if (this.memberService.getLoginUserRole() === this.enumRole.SUPER_ADMIN) {
        this.router.navigate(['login/superadmin']);
      }
      else {
        if (this.memberService.getUserAccess() === this.enumRole.ADMIN_PROVIDER)
          this.router.navigate(['login/adminProvider']);
        else
          this.router.navigate(['login/provider']);
      }
      this.memberService.clearLoginUserRole();
    }, 300);
  }


  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const profileEl = this.eRef.nativeElement.querySelector('.profile-wrapper');
    if (profileEl && !profileEl.contains(event.target)) {
      this.showDropdown = false;
    }

    const notificationEl = this.eRef.nativeElement.querySelector('.notification-wrapper');
    if (notificationEl && !notificationEl.contains(event.target)) {
      this.showNotifications = false;
    }
  }

  // Removed old mouseleave handlers - now using global mouse move approach

  /**
   * Check if mouse is within the profile area (icon + dropdown)
   */
  isMouseInProfileArea(event: MouseEvent): boolean {
    const profileWrapper = this.eRef.nativeElement.querySelector('.profile-wrapper');
    const dropdownMenu = this.eRef.nativeElement.querySelector('.dropdown-menu');

    if (!profileWrapper || !dropdownMenu) {
      return false;
    }

    const rect = profileWrapper.getBoundingClientRect();
    const dropdownRect = dropdownMenu.getBoundingClientRect();

    // Create a combined area that covers both the profile icon and dropdown
    const combinedRect = {
      left: Math.min(rect.left, dropdownRect.left),
      right: Math.max(rect.right, dropdownRect.right),
      top: Math.min(rect.top, dropdownRect.top),
      bottom: Math.max(rect.bottom, dropdownRect.bottom)
    };

    return (
      event.clientX >= combinedRect.left &&
      event.clientX <= combinedRect.right &&
      event.clientY >= combinedRect.top &&
      event.clientY <= combinedRect.bottom
    );
  }

  /**
   * Global mouse move handler to check if cursor is in profile area
   */
  @HostListener('document:mousemove', ['$event'])
  onGlobalMouseMove(event: MouseEvent): void {
    if (this.showDropdown && !this.isMouseInProfileArea(event)) {
      // Add a small delay to prevent flickering
      setTimeout(() => {
        if (!this.isMouseInProfileArea(event)) {
          this.showDropdown = false;
        }
      }, 150);
    }
  }

  /**
   * Handle profile mouse enter - open dropdown
   */
  onProfileMouseEnter(): void {
    this.showDropdown = true;
  }

}
